import { render } from "./servicesCards.vue?vue&type=template&id=0d350c18&scoped=true"
const script = {}

import "./servicesCards.vue?vue&type=style&index=0&id=0d350c18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d350c18"]])

export default __exports__